import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
// import { Destination } from "../destination/destination.entity";
// import { Vendors } from "../vendors/vendors.entity";

@Entity('downtime_reason')
export class DownTimeReason{
    @PrimaryGeneratedColumn("increment",{name:'downtimereason_id'})
    downtimereasonId:number;

    @Column("char",{
      nullable:false,
      length:100,
      name:"downtime_reason"
    })
    downtimeReason:string;


  @Column("char",{
    nullable:true,
    length:50,
    name:"downtime_status"
    })
// @Index({ unique: true })
downtimestatus:string;

@Column("int",{
  name:"sla"
})
sla:number;

@Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      default:1,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

}